import React, { PropsWithChildren, useMemo, useState } from 'react';
import DossierValidationHeaderContext from './DossierValidationHeaderContext';

const DossierValidationHeaderProvider: React.FunctionComponent<PropsWithChildren> = function ({
    children,
}) {
    const [isDossierValidationPath, setDossierValidationPath] = useState<boolean>(false);
    // useState receives a lazy initializer; to initialize the state with a function value
    // provide a function that returns the actual callback function
    const [onExit, setOnExit] = useState<() => void>(() => () => {});
    const [headerTitle, setHeaderTitle] = useState<string>('Vérifier les informations du dossier');
    const [headerButton, setHeaderButton] = useState<string>('Enregister et quitter');
    const [pathOnExit, setPathOnExit] = useState<string | null>(null);

    const contextValue = useMemo(
        () => ({
            isDossierValidationPath,
            setDossierValidationPath,
            onExit,
            setOnExit,
            headerTitle,
            setHeaderTitle,
            headerButton,
            setHeaderButton,
            pathOnExit,
            setPathOnExit,
        }),
        [
            isDossierValidationPath,
            setDossierValidationPath,
            onExit,
            setOnExit,
            headerTitle,
            setHeaderTitle,
            headerButton,
            setHeaderButton,
            pathOnExit,
            setPathOnExit,
        ],
    );

    return (
        <DossierValidationHeaderContext.Provider
            value={contextValue as React.ContextType<typeof DossierValidationHeaderContext>}
        >
            {children}
        </DossierValidationHeaderContext.Provider>
    );
};

export default DossierValidationHeaderProvider;
